import React, { useState } from 'react'
import MainLayout from '../../layouts/Main'

// import { useGetUserCampuses } from '../../../hooks/campuses';
import { useExportUserVisitsReportForSchool, useGetUserVisitsReportForSchool } from '../../../hooks/analytics';

import BarChart from '../../sub_components/charts/BarChart';
import ReportTablet from '../../sub_components/ReportTablet';
import FilterTable from '../../sub_components/tables/FilterTable';
import ReportDatePicker from '../../sub_components/ReportDatePicker';

import { IColumnProps, IFilterableDataProps } from '../../../interfaces/tables';

import { getDateString } from '../../../helpers/utility';

const UserVisitsReport = () => {
    // let filterTableDataColumns__Campuses: IColumnProps[] = [
    //     { name: "ID", identifier: "id" },
    //     { name: "Campus", identifier: "name" },
    // ];
    let filterTableDataColumns__UserVisitsReport: IColumnProps[] = [
        { name: "ID", identifier: "id" },
        { name: "Full Name", identifier: "full_name" },
        { name: "Email", identifier: "email" },
        { name: "Visits", identifier: "visits" },
        { name: "Last Visit", identifier: "last_visit" },
    ];

    // let filterTableData__Campuses: IFilterableDataProps[] = [];
    let filterTableData__UserVisitsReport: IFilterableDataProps[] = [];


    const [campusFilters, setCampusFilters] = useState<number[]>([]); // eslint-disable-line
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");

    const filterQuery = new URLSearchParams();
    filterQuery.set("start_date", startDate);
    filterQuery.set("end_date", endDate);
    campusFilters.forEach((id) => filterQuery.append("campus_ids", id.toString()));

    // const { data: campuses } = useGetUserCampuses();
    const { data: userVisitsReport } = useGetUserVisitsReportForSchool(filterQuery.toString());
    
    const { mutate: exportCsv } = useExportUserVisitsReportForSchool();

    // if (campuses) {
    //     filterTableData__Campuses = campuses.map((campus) => ({
    //         id: campus.id,
    //         name: campus.name,
    //     }));
    // }

    if (userVisitsReport) {
        filterTableData__UserVisitsReport = userVisitsReport.table_data.map((user) => ({
            id: user.id,
            full_name: user.full_name,
            email: user.email,
            visits: user.visits,
            last_visit: getDateString(user.last_visit),
        }));
    }

    const onExportCsv = () => {
        exportCsv({ payload: { filterQuery: filterQuery.toString() } });
    }

    return (
        <MainLayout>
            <div className='immersion__careers_report'>
                <div className='immersion__careers_report__header'>
                    <div className='immersion__careers_report__header__content'>
                        <h2 className='immersion__careers_report__header__content__title'>User Visits Report</h2>
                        <p className='immersion__careers_report__header__content__description'>
                            This slide gives an overview of users who have visited the platform since the start of data collection (20/04/24).
                            The chart to the bottom left shows a cumulative timeline of visits to the platform.
                            The table to the bottom right shows the latest date a user has had activity on the platform.
                        </p>
                    </div>
                    <div className='immersion__careers_report__header__actions'>
                        <button className='immersion__btn immersion__btn__primary immersion__careers_report__header__actions__button' onClick={onExportCsv}>Export CSV</button>
                    </div>
                </div>
                <div className='immersion__careers_report__chart_body'>
                    <div className='immersion__careers_report__chart__row'>
                        {/* {campuses?.length
                            ? <FilterTable
                                columns={filterTableDataColumns__Campuses}
                                data={filterTableData__Campuses}
                                filters={campusFilters}
                                setFilters={setCampusFilters}
                                enableFilters={true}
                            />
                            : <div className='immersion__careers_report__chart__no_data'>
                                No campuses found
                            </div>
                        } */}
                        <div className='immersion__careers_report__chart__row immersion__careers_report__chart__row__vertical'>
                            <ReportDatePicker
                                required={true}
                                startDate={startDate}
                                setStartDate={setStartDate}
                                endDate={endDate}
                                setEndDate={setEndDate}
                            />
                            <ReportTablet
                                title={userVisitsReport?.total_unique_visits?.toString() ?? "0"}
                                description='Total Unique Visits'
                                color={'green'}
                            />
                        </div>
                    </div>
                    <div className='immersion__careers_report__chart__row'>
                        <FilterTable
                            columns={filterTableDataColumns__UserVisitsReport}
                            data={filterTableData__UserVisitsReport}
                            filters={[]}
                            setFilters={() => { }}
                            enableFilters={false}
                        />
                        {userVisitsReport?.page_view_chart_data.length ? (
                            <BarChart
                                data={userVisitsReport?.page_view_chart_data ?? []}
                                width={600}
                                height={318}
                                xLabel=""
                                yLabel="Total Unique Visits"
                                xTickAngle={90}
                                xInterval={0}
                            />
                        ) : (
                            <div className='immersion__careers_report__chart__no_data'>
                                No analytics data available
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </MainLayout >
    );
};

export default UserVisitsReport;